import logo from './mexico.PNG';

export const aboutData = {
    title: "Quién Soy",
    description1: "Yo soy Omar Arteaga. ",
    description2: "Y vengo de muy humildes comienzos. Con mucho trabajo y dedicación, he logrado construir el negocio que hoy tenemos. Siempre he tenido a mi familia como pilar fundamental, y ellos son los que me motivan a seguir adelante. ¡Ven y conoce lo que tenemos para ofrecer! ",
    image: logo
}